/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CityDto { 
    uuid?: string;
    name?: string;
    names?: { [key: string]: string; };
    descriptions?: { [key: string]: string; };
    civilization?: string;
    capital?: boolean;
    walled?: boolean;
}